import React, { useState } from "react";
import api, { formatApiErrorDetail as fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

const today = () => new Date().toLocaleDateString("en-CA");

export default function LeaveDialog({ onClose, onCreated }) {
  const [start, setStart] = useState(today());
  const [end, setEnd] = useState(today());
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const days = start && end && end >= start ? Math.round((new Date(end) - new Date(start)) / 86400000) + 1 : 0;

  const submit = async () => {
    if (!reason.trim()) { toast.error("Please add a reason"); return; }
    if (!days) { toast.error("End date must be on or after start date"); return; }
    setLoading(true);
    try {
      await api.post("/leaves", { start_date: start, end_date: end, reason });
      toast.success("Leave request submitted");
      onCreated?.(); onClose();
    } catch (e) { toast.error(fmtErr(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="leave-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Request leave</DialogTitle>
          <DialogDescription>HR will review and you'll be notified of the decision.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-1">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2"><Label>Start date</Label><Input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="leave-start-input" /></div>
            <div className="space-y-2"><Label>End date</Label><Input type="date" value={end} min={start} onChange={(e) => setEnd(e.target.value)} data-testid="leave-end-input" /></div>
          </div>
          <p className="text-xs text-slate-500" data-testid="leave-days-count">{days ? `${days} day${days > 1 ? "s" : ""}` : "Invalid date range"}</p>
          <div className="space-y-2"><Label>Reason</Label><Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Family function" data-testid="leave-reason-input" /></div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button onClick={submit} disabled={loading} className="bg-indigo-600 hover:bg-indigo-700" data-testid="leave-submit-button">
            {loading ? "Submitting…" : "Submit request"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
